import { useUtilityContext } from '@change-corgi/core-react/utilityContext';
import type { PaymentMethodUsage } from '@change-corgi/middle-end-gql-schema';

import { useSetupAndConfirm } from '#src/app/shared/components/payments';
import type { PaymentType } from '#src/app/shared/utils/payments';
import { saveStripePaymentMethod } from '#src/app/shared/utils/payments';

type Params = {
	paymentType: PaymentType;
	token?: string;
	accountId?: string;
	tokenType?: 'temporary' | 'permanent';
	usage: PaymentMethodUsage;
	email: string;
	countryCode: string;
	currencyCode: string;
	locale?: string;
};

export function useStripePermanentPaymentMethod(): (params: Params) => Promise<void> {
	const utilityContext = useUtilityContext();
	const setupAndConfirmPaymentMethod = useSetupAndConfirm();

	return async (params): Promise<void> => {
		const { token, usage, email, paymentType, tokenType, countryCode, currencyCode, accountId, locale } = params;
		const paymentMethod = { id: token };

		if (tokenType === 'temporary' && paymentMethod.id) {
			await saveStripePaymentMethod({
				token: paymentMethod.id,
				email,
				usage,
				utilityContext,
				paymentType,
				accountId,
				locale,
				countryCode,
			});
		}

		await setupAndConfirmPaymentMethod({
			paymentMethod,
			usage,
			paymentType,
			countryCode,
			currencyCode,
			accountId,
		});
	};
}
